import GridProduct from '../../products/product/grid-product';
import CloseIcon from '../../../ui/svg/common/close';
import React from 'react';
import { IListItem } from '../../list-page/interfaces/interfaces';
import { rootActions, useAppDispatch, useAppSelector } from '../dal/store';
import { ICompareBundlesData } from '../interfaces';
import { formatData, removeDocFromCompareBundles } from '../domain/compare-bundles-provider';

const tdStyle= {
    width: '20%',
    verticalAlign: 'top',
    height: 'inherit,'
};

const removeIconStyle = {
    right: '13px',
    top: '5px',
};

interface IBundle {
    bundle: IListItem;
}

const Bundle = (props: IBundle) => {

    const { bundle } = props;
    const dispatch = useAppDispatch();

    const data = useAppSelector(store => store.root.data);
    const documentIDs = useAppSelector(store => store.root.documentIDs);

    const removeBundle = () => {

        const copy: ICompareBundlesData = JSON.parse(JSON.stringify(data));

        const bundleIndex = copy.bundles.findIndex(b => b.skuid === bundle.skuid);
        if(bundleIndex === -1) return;

        copy.bundles.splice(bundleIndex, 1);

        const documentIDsCopy = [...documentIDs];
        const idIndex = documentIDsCopy.findIndex(id => id === bundle.documentID);
        if(idIndex !== -1) {
            documentIDsCopy.splice(idIndex, 1);
        }

        dispatch(
            rootActions.main({
                data: formatData(copy),
                documentIDs: documentIDsCopy,
            })
        );

        let url = window.location.pathname;
        if(documentIDsCopy.length > 0){
            url += `?ids=${ documentIDsCopy.join('-') }`;
        }

        window.history.replaceState({}, '', url);

        removeDocFromCompareBundles(bundle.documentID);
    };

    return (
        <td
            style={ tdStyle }
            className="px-2 pb-4 border-l relative">

            <GridProduct
                product={ bundle }
                classes="h-full"
                isPriceClockHidden={ true }
                disableImageLazy={true}
            />

            <button
                type="button"
                onClick={ removeBundle }
                className="absolute"
                style={ removeIconStyle }>
                <CloseIcon
                    width="15px"
                    color="#828282"
                    title="Remove"
                />
            </button>
        </td>
    )
};

export default Bundle;